<script setup lang="ts">
const model = defineModel<string>();
</script>

<template>
  <v-tabs v-model="model" color="primary" class="custom-tabs">
    <slot />
  </v-tabs>
</template>

<style scoped lang="scss">
.custom-tabs :deep(.v-slide-group__content) {
  border-bottom: 2px solid $color-line-divider;
}
</style>
